<!-- vue2 google maps -->
<!-- https://www.npmjs.com/package/vue2-google-maps -->

<template>
	<div class="googlemaps">
		<GmapMap
			:center="centerPos"
			:zoom="14"
			map-type-id="roadmap"
			style="width: 100%; height: 100%;"
			:options="mapOptions"
		>
			<!-- Multiple markers -->
			<div v-if="hasMultiMarkers">
				<!-- 
				averageCenter (Type: Boolean)
				batchSizeIE (Type: Number)
				calculator (Type: Function)
				enableRetinaIcons (Type: Boolean)
				gridSize (Type: Number)
				ignoreHidden (Type: Boolean)
				imageExtension (Type: String)
				imagePath (Type: String)
				imageSizes (Type: Array)
				maxZoom (Type: Number)
				minimumClusterSize (Type: Number)
				styles (Type: Array)
				zoomOnClick (Type: Boolean)
				-->
				<GmapCluster
					:zoomOnClick="true"
					:styles="clusterStyle"
					:minimumClusterSize="3"
					:maxZoom="20"
				>
					<GmapMarker
						v-for="(m, j) in markers"
						:key="j"
						:position="m.position"
						:clickable="true"
						:draggable="false"
						:icon="{
							url: 'https://boka.klappen.se/icon-map-pin.png',
							scaledSize: { width: 53, height: 63 }
						}"
						@click="goToAccommodation(m)"
					>
						<GmapInfoWindow :position="m.position" :opened="false">
							<!-- <div class="infoWindow">
								<router-link
									:to="{ name: 'accommodation', ...urlToAccommodation(n) }"
								>
									<span>{{ n.distanceToLift }}</span>
								</router-link>
							</div> -->
							<span>{{ m.title }}</span>
							<router-link
								:to="{ name: 'accommodation', ...urlToAccommodation(m) }"
							>
								<span>
									<br />
									Visa och boka
								</span>
							</router-link>
						</GmapInfoWindow>
					</GmapMarker>
				</GmapCluster>
			</div>

			<!-- Single marker -->
			<div v-if="!hasMultiMarkers">
				<GmapMarker
					v-for="(m, j) in markers"
					:key="j"
					:position="m.position"
					:clickable="true"
					:draggable="false"
					:icon="{
						url: 'https://boka.klappen.se/icon-map-pin.png',
						scaledSize: { width: 53, height: 63 }
					}"
					@click="center = m.position"
				/>
			</div>
		</GmapMap>
	</div>
</template>

<script>
import store from '../../vueX/store'

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues

Vue.use(VueGoogleMaps, {
	load: {
		//Production api key
		key: 'AIzaSyBuIUf5O64UShfhsO08uJ4cuyLZs5rtwbI',
		//Test api key
		//key: "AIzaSyAlvy1ZOMBX6NUpsPgFg2EdIWHLX-7F3Jw",
		libraries: 'places',
		v: '3.80'
	}
})

export default {
	name: 'Googlemaps',
	components: {
		GmapCluster
	},
	data() {
		return {
			center: { lat: 45.508, lng: -73.587 },
			mapOptions: {
				zoomControl: true,
				mapTypeControl: true,
				disableDefaultUI: true,
				fullscreenControl: true,
				styles: []
			},
			clusterStyle: [
				{
					textColor: '#2A3E61',
					textSize: 18,
					url: 'https://boka.klappen.se/icon-map-cluster.png',
					height: 61,
					width: 61
				}
				// {
				// 	textColor: '',
				// 	textSize: 123,
				// 	url: 'path/to/medium/cluster.png',
				// 	height: 1,
				// 	width: 2,
				// 	anchor: [0, 0],
				// 	iconAnchor: [0, 0],
				// 	backgroundPosition: 'center, center'
				// },
				// {
				// 	textColor: '',
				// 	textSize: 123,
				// 	url: 'path/to/large/cluster.png',
				// 	height: 1,
				// 	width: 2,
				// 	anchor: [0, 0],
				// 	iconAnchor: [0, 0],
				// 	backgroundPosition: 'center, center'
				// },
			]
		}
	},
	props: {
		hasMultiMarkers: {
			type: Boolean,
			default: false
		},
		markers: {
			type: Array,
			default: () => []
		},
		centerPos: {
			type: Object,
			default: () => {
				return {
					lat: 61.0346393,
					lng: 13.3462451
				}
			}
		}
	},
	methods: {
		urlToAccommodation(each) {
			const query = this.$route.query

			return {
				params: {
					id: `${each.title.replace(/ /g, '-')}_${each.poollid}_${each.unitlid}`
				},
				query: {
					s: query.s ? query.s : undefined,
					e: query.e ? query.e : undefined,
					c: query.c ? query.c : undefined,
					y: query.y ? query.y : undefined,
					a: query.a ? query.a : 2,
					cc: query.cc ? query.cc : undefined
				}
			}
		},
		goToAccommodation(accommodationObject) {
			this.$router.push({
				name: 'accommodation',
				...this.urlToAccommodation(accommodationObject)
			})
		}
	},
	computed: {
		langUrl: function () {
			const getlangFromUrl = window.location.href.includes('/en/')
			if (getlangFromUrl) {
				return '/en/boka/'
			}
			return '/boka/'
		},
		datesAndPeople: function () {
			return store.state.accommodation.datesAndPeople
		}
	}
}
</script>

<style lang="scss">
// button.gm-ui-hover-effect {
// 	display: none !important;
// }
// .gm-style .gm-style-iw-c {
// 	color: #ffffff;
// 	font-family: Saira, sans-serif;
// 	background-color: #04befb;
// 	box-shadow: none;
// 	border-radius: 0;
// 	font-size: 12px;
// 	font-weight: 600;
// 	line-height: 18px;
// 	padding: 0;
// }
// .gm-style .gm-style-iw-t::after {
// 	background: #04befb;
// 	box-shadow: none;
// 	width: 10px;
// 	height: 10px;
// }
// .gm-style-iw-d {
// 	overflow: hidden !important;
// 	padding: 5px 10px;
// 	background-color: #04befb;
// }
// .infoWindow a {
// 	color: white;
// 	&:hover {
// 		text-decoration: none;
// 		color: white;
// 	}
// }
</style>
